/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import moment from 'moment'
import { saveAs } from 'file-saver'
import { history } from 'index'
import { notification } from 'antd'
import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'
import { setPageSize, setCurrentPage } from 'redux/settings/actions'
import { isEmpty } from 'lodash'

const ApiEndPoints = {
  LOGIN: 'auth/login',
  GLOBAL_TYPE_CATEGORY: 'globaltypecategory/',
  GLOBAL_TYPE_CATEGORY_STATUS: 'globaltypecategory/status/',
  MASTER_GLOBAL_TYPE_CATEGORY: 'globalType/masterglobaltype/',
  SINGLE_MASTER_GLOBAL_TYPE_CATEGORY: 'globalType/singleMasterGlobalType/',
  NESTED_GLOBAL_TYPE: 'globalType/nestedGlobaltype/',
  GLOBAL_TYPE: 'globaltype/',
  GLOBAL_TYPE_STATUS: 'globaltype/status/',
  GET_TRAINING_FOR: 'getTrainingFor/',

  MARK_LEAVE: 'employee/markLeave',
  UPDATE_LEAVE: 'employee/updateLeave',
  LEAVE_COUNT: 'employee/getLeaveCount',
  ALL_LEAVE: 'employee/allEmployee-leave',
  LEAVE_REQUEST: 'employee/leaveRequest',
  UPDATE_LEAVE_STATUS: 'employee/updateLeaveStatus',
  DELETE_LEAVE_REQUEST: 'employee/deleteLeaveRequest',
  GET_SINGLE_LEAVE_REQUEST: 'employee/getSingleRequestData',
  ALL_DAYOFF_LEAVE: 'employee/allEmployeeDay-leave',

  RAG_STATUS_LIST: 'employee/getRAGEmployee',
  UPDATE_RYG_EMPLOYEE: 'employee/updateRYGEmployee',
  UPDATE_HIERARCHY: 'hierarchy/updateHierarchy',
  EVENTS: 'event/',
  TEAM_LIST: 'teamList/',
  EXPENSES: 'expenses/',
  MEDIA: 'media/',
  EXPENSES_DOC: 'expensesDoc',
  REIMBURSMENT: 'reimbursement',
  REIMBURSMENT_DOC: 'reimbursementDoc',
}

export const utcToDate = (utc) => {
  const date = moment(utc).format('YYYY-MM-DD')
  return date
}
export const changeDateFormat = (value) => {
  const date = moment(value).format('YYYY/MM/DD')
  return date
}
export const utcToIst = (utc) => {
  const ist = moment.utc(utc).local().format('h:mm A')
  return ist
}
export const capitalizeFirstLetter = (string) => {
  if (string === (undefined || null)) return null
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const formatDate = (date) => {
  const formattedDate = moment(date).format('YYYY-MM-DD')
  return moment(formattedDate, 'YYYY-MM-DD')
}

export const DateFormater = (date) => {
  const formattedDate = moment(date).format('YYYY-MM-DD')

  return formattedDate
}

export const localToUTC = (date) => {
  return moment(date, 'YYYY-MM-DD').utc()
}
// Returns an array of dates between the two dates
export const getDates = (startDate, endDate) => {
  const date = new Date(startDate.getTime())

  const dates = []

  while (date <= endDate) {
    dates.push(new Date(date))
    date.setDate(date.getDate() + 1)
  }

  return dates
}

export const convertToCSV = (data) => {
  const header = `${Object.keys(data[0]).join(',')}\n`
  const rows = data.map((row) => `${Object.values(row).join(',')}\n`).join('')
  return header + rows
}

export const manageCSVDownload = (tableData) => {
  const csvData = convertToCSV(tableData)
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
  saveAs(blob, 'table-data.csv')
}

export const logoutUser = () => {
  Cookies.remove('accessToken')
  Cookies.remove('permissions')
  history.push('/auth/login')
}

const displayErrorMsg = (error) => {
  notification.error({
    message: 'Error',
    description: error?.response?.data?.message,
  })
}
export const handelError = (error) => {
  if (error?.response?.data?.statusCode === (401 || 403)) {
    displayErrorMsg(error)
    logoutUser()
  } else {
    displayErrorMsg(error)
  }
}
export const generateYears = () => {
  const startYear = 2018
  const endYear = new Date().getFullYear()
  const years = []
  for (let year = startYear; year <= endYear; year += 1) {
    years.push({ label: year.toString(), value: year.toString() })
  }
  return years.reverse()
}
// export const Years = [
//   { label: '2023', value: '2023' },
//   { label: '2022', value: '2022' },
//   { label: '2021', value: '2021' },
//   { label: '2020', value: '2020' },
//   { label: '2019', value: '2019' },
//   { label: '2018', value: '2018' },
// ]
export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
export const monthArray = [
  { label: 'Jan', value: '01' },
  { label: 'Feb', value: '02' },
  { label: 'Mar', value: '03' },
  { label: 'Apr', value: '04' },
  { label: 'May', value: '05' },
  { label: 'Jun', value: '06' },
  { label: 'Jul', value: '07' },
  { label: 'Aug', value: '08' },
  { label: 'Sep', value: '09' },
  { label: 'Oct', value: '10' },
  { label: 'Nov', value: '11' },
  { label: 'Dec', value: '12' },
]
export const getYears = () => {
  const baseYear = 2024
  const currentYear = new Date().getFullYear()
  const startYear = Math.min(baseYear, currentYear)
  const endYear = currentYear + 5

  return [...Array(endYear - startYear + 1).keys()].map((year) => ({
    label: (startYear + year).toString(),
    value: startYear + year,
  }))
}

export const AnswerType = [
  { label: 'Subjective', value: 'subjective' },
  { label: 'MCQ', value: 'mcq' },
]
export const SelectionType = [
  { label: 'Single', value: 0 },
  { label: 'Multiple', value: 1 },
]
export const getLoggedInUserInfo = () => {
  const token = Cookies.get('accessToken')
  const userData = Cookies.get('userData')

  if (token && userData) {
    try {
      const decodedToken = jwt.decode(token)
      const userInfo = JSON.parse(userData)

      return {
        userId: userInfo.user_id || decodedToken?.user_id,
        username: userInfo.username || decodedToken?.username,
        customerId: userInfo.customer_id || decodedToken?.customer_id,
        userRole: userInfo.user_role || decodedToken?.userRole,
        customerName: userInfo.customer_name || decodedToken?.customer_name,
        // Add other fields you need from either source
      }
    } catch (error) {
      console.error('Error parsing user data:', error)
      return null
    }
  }
  return null
}

// utils/featureUtils.js
// export const hasFeatureAccess = (requiredFeature) => {
//   const features = JSON.parse(Cookies.get('features'))|| [];
//   // const userInfo = getLoggedInUserInfo();

//   // Super admin has access to everything
//   // if (userInfo?.userRole === 'super_admin') {
//   //   return true;
//   // }

//   return features.includes(requiredFeature);
// };

export const hasFeatureAccess = (requiredFeature) => {
  const features = JSON.parse(Cookies.get('features') || '[]')
  // const userInfo = getLoggedInUserInfo();

  // Super admin has access to everything
  // if (userInfo?.userRole === 'super_admin') {
  //   return true;
  // }

  return features.includes(requiredFeature)
}

export const hourConversion = (minutes) => {
  if (!Number.isNaN(minutes)) {
    const hour = Math.floor(minutes / 60)
    const minute = minutes % 60
    return `${hour} Hours ${minute} Minutes`
  }
  return null
}
export const downloadPdf = (mediaLink) => {
  const protocol = window?.location?.protocol
  const baseURL =
    process.env.NODE_ENV === 'development' ? 'localhost:5000' : process.env.REACT_APP_PROD_BASE_URL
  // const downloadLink = `${protocol}//${baseURL}/${mediaLink}`
  const downloadLink =
    process.env.NODE_ENV === 'development'
      ? `${protocol}//${baseURL}/${mediaLink}`
      : `//${baseURL}/${mediaLink}`
  const fileName = downloadLink.split('/').pop()
  fetch(downloadLink)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => console.error('Error downloading PDF:', error))
}
export const filterOption = (input, option) => {
  return option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

export const resetPagination = { skip: 0, limit: 10 }
export const defaultPagination = (dispatch) => {
  dispatch(setCurrentPage(1))
  dispatch(setPageSize(10))
}

export const onPageChange = ({
  totalCount,
  pageSize,
  currentPage,
  oldPageSize,
  pageNumber,
  dispatch,
  handlePagination,
}) => {
  const lastPage = Math.ceil(totalCount / pageSize)
  if (currentPage !== pageNumber && (currentPage <= lastPage || currentPage === 2)) {
    const pageLimit = parseInt(pageNumber * oldPageSize, 10)
    const pageSkip = parseInt(pageLimit - oldPageSize, 10)
    dispatch(
      handlePagination({
        limit: pageLimit,
        skip: pageSkip,
      }),
    )
    dispatch(setCurrentPage(pageNumber))
  } else {
    dispatch(setCurrentPage(1))
  }
}

export const onPageSizeChange = ({ oldPageSize, pageSize, dispatch, handlePagination }) => {
  if (oldPageSize !== pageSize) {
    const pageLimit = parseInt(pageSize, 10)
    const pageSkip = parseInt(pageLimit - Number(pageSize), 10)
    dispatch(
      handlePagination({
        limit: pageLimit,
        skip: pageSkip,
      }),
    )
    dispatch(setPageSize(pageSize))
  }
}

export const Permissions = {
  READ: 'read',
  ADD: 'add',
  UPDATE: 'update',
  SHOW_ACTIVE_TOGGLE: 'show-active-toggle',
  DOWNLOAD_DATA: 'download-data',
  UPLOAD_DATA: 'upload-data',
  SEARCH_FILTERS: 'search-filters',
  WRITE: 'write',
}
export const ModuleUniqueValues = {
  EMPLOYEES: 'employees',
  ATTENDANCE: 'attendance',
  ROSTER: 'roster',
  DOWN_TIME: 'down_time',
  EXCEPTION: 'exception',
  GLOBAL_TYPE: 'global_type',
  GLOBAL_TYPE_CATEGORY: 'global_type_category',
  MODULE_PERMISSION: 'module_permission',
  TERMS_AND_CONDITION: 'terms_and_condition',
  COMPANY_POLICY: 'company_policy',
  LEAVE_POLICY: 'leave_policy',
  AGENTS: 'agents',
  DASHBOARD: 'dashboard',
  ROLE_AND_PERMISSIONS: 'role_and_permissions',
  HAPPY_TO_HELP: 'happy_to_help',
  RYG_STATUS: 'ryg_status',
  RESIGNATION: 'resignation',
  ONBOARD: 'on_board',
  REIMBURSEMENT: 'reimbursement',
}

export const formHintBoxMessage = {
  PASSWORD: (
    <div style={{ padding: '5px', minWidth: '100px' }}>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 6 character long</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 upper letter</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 special symbol</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Atleast 1 number</p>
    </div>
  ),
  EMAIL: <p style={{ margin: 0, fontSize: '12px' }}>Enter a valid email for notification</p>,
  NAME: <p style={{ margin: 0, fontSize: '12px' }}>Name should be match your Id proof</p>,
  PHONE_NUMBER: <p style={{ margin: 0, fontSize: '12px' }}>Enter a valid mobile number</p>,
  COMMUNICATION_WITH: (
    <p style={{ margin: 0, maxWidth: '210px', fontSize: '12px' }}>
      To whom do you want to communicate in order to resolve your issue
    </p>
  ),
  CONCERN_DATE: <p style={{ margin: 0, fontSize: '12px' }}>Date related to issue invoke</p>,
  BELONGS_TO: <p style={{ margin: 0, fontSize: '12px' }}>Major field for issue</p>,
  DOWN_TIME: <p style={{ margin: 0, fontSize: '12px' }}>Reason for the down time</p>,
  RESIGNATION: <p style={{ margin: 0, fontSize: '12px' }}>Reason for the resignation</p>,
  UNIQUE_VALUE: (
    <div style={{ padding: '5px', maxWidth: '500px' }}>
      <p style={{ margin: 0, fontSize: '12px' }}>- Space will be treated as underscore</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Only string is allowed</p>
      <p style={{ margin: 0, fontSize: '12px' }}>- Max 30 character allowed</p>
    </div>
  ),
  MONTH_RECORD: <p style={{ margin: 0, fontSize: '12px' }}>Click to see month's record</p>,
  TRAINING_END_DATE: (
    <p style={{ margin: 0, fontSize: '12px' }}>
      Training End Date will be changed according to the training duration
    </p>
  ),
  TRAINING_DURATION: (
    <p style={{ margin: 0, fontSize: '12px' }}>
      {' '}
      Training duration will be changed according to training type.
    </p>
  ),
}

export const CheckPermission = ({ moduleUniqueValue, permission, children }) => {
  const { userRole, userRoles } = getLoggedInUserInfo()
  let showComponent = false
  if (userRole === 'super_admin') {
    showComponent = true
  } else if (!isEmpty(userRoles)) {
    const allPermissions = userRoles[moduleUniqueValue]
    showComponent = allPermissions?.includes(permission)
  }

  return <>{showComponent ? children : null}</>
}

export const getColor = (status) => {
  switch (status) {
    case 0:
      return 'warning'
    case 1:
      return 'success'
    default:
      return 'error'
  }
}
export const getStatusLabel = (status) => {
  let color
  let displayStatus

  switch (status) {
    case 0:
      color = getColor(status)
      displayStatus = 'Pending'
      break
    case 1:
      color = getColor(status)
      displayStatus = 'Accepted'
      break
    case 2:
      color = getColor(status)
      displayStatus = 'Rejected'
      break
    case 'certified':
      color = 'green'
      displayStatus = 'Certified'
      break
    default:
      color = getColor(status)
      displayStatus = status
      break
  }

  return { color, displayStatus }
}
export const getAttendeanceLabel = (status) => {
  let color
  let displayStatus

  switch (status) {
    case 0:
      color = getColor(status)
      displayStatus = 'Absent'
      break
    case 1:
      color = getColor(status)
      displayStatus = 'Present'
      break
    default:
      color = getColor(status)
      displayStatus = status
      break
  }

  return { color, displayStatus }
}
export const tooltip = (props) => {
  return props
}
export const uploadButtonContent = (
  <div>
    <p>Upload pdf only</p>
  </div>
)

export default ApiEndPoints
